import React, { useState, useEffect, useRef } from "react";
import "./LanguageSelector.css";
import { fetchLanguages } from "../../Utils/functions";

const LanguageSelector = ({ selectedLanguage, onLanguageChange }) => {
  const [languages, setLanguages] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  const handleLanguageClick = (language) => {
    onLanguageChange(language);
    setIsOpen(false);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  useEffect(() => {
    const loadLanguages = async () => {
      try {
        const data = await fetchLanguages();
        setLanguages(data.languages);
        const selectedLang = data.languages.find((lang) => lang.isSelected);
        if (selectedLang && !selectedLanguage) {
          onLanguageChange(selectedLang.name);
        }
      } catch (error) {
        console.error("Failed to load languages", error);
      }
    };
    loadLanguages();
  }, []);

  const currentLanguage =
    languages.find((lang) => lang.name === selectedLanguage) || {};

  return (
    <div className="language-selector" ref={wrapperRef}>
      <button
        className="language-select-button"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>{currentLanguage.name || selectedLanguage || "English"}</span>
        <svg
          className={`chevron-icon ${isOpen ? "open" : ""}`}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
            fill="currentColor"
          />
        </svg>
      </button>
      {isOpen && (
        <ul className="language-options">
          {languages.map((lang) => (
            <li
              key={lang.code}
              className={`language-option ${
                lang.name === selectedLanguage ? "selected" : ""
              }`}
              onClick={() => handleLanguageClick(lang.name)}
            >
              <svg
                className="checkmark-icon"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
              </svg>
              {lang.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageSelector;
